/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import { observable, action, flow, ObservableMap } from 'mobx';
import ErrorsStore from './errorsStore';
import fetch from '../fetch';
import _ from '../translations';

class StripeStore {
    constructor() {
        this.baseUrl = '/api/stripe/admin';
    }

    @observable collection = new ObservableMap();
    @observable details = new ObservableMap();

    @action
    reset = () => {
        this.collection.clear();
        this.details.clear();
    };

    @action
    createCreditCard = flow(function*({ item = {} } = {}) {
        let customError = _('There was a problem creating the credit card');
        try {
            const detail = yield fetch.post({
                url: `${this.baseUrl}/createCustomerCard`,
                body: { data: item },
            });
            if (detail.error) {
                ErrorsStore.addError(detail, customError);
            } else {
                ErrorsStore.addSuccess(
                    { userMessage: _('Credit Card created successfully') },
                    _('Operation Successfull')
                );
            }
            this.details.set(item.customer_id, detail);
            return detail;
        } catch (e) {
            ErrorsStore.addError(e, customError);
            console.warn(e);
            return false;
        }
    });

    @action
    getCustomer = flow(function*({ params }) {
        let customError = _('There was a problem list the credit card');
        this.details.set(params.customer_id, {
            loading: true,
        });

        try {
            const detail = yield fetch.get({
                url: `${this.baseUrl}/getCustomer/${params.customer_id}`,
                params: {},
            });
            if (detail.error) {
                ErrorsStore.addError(detail, customError);
            }
            this.details.set(params.customer_id, detail);
        } catch (e) {
            ErrorsStore.addError(e, customError);
            console.warn(e);
        }
    });

    @action
    changeCustomerCard = flow(function*(item) {
        let customError = _('There was a problem creating the credit card');
        try {
            const detail = yield fetch.post({
                url: `${this.baseUrl}/changeCustomerCard`,
                body: { data: item },
            });
            if (detail.error) {
                ErrorsStore.addError(detail, customError);
            } else {
                ErrorsStore.addSuccess(
                    { userMessage: _('Credit Card changed successfully') },
                    _('Operation Successfull')
                );
            }
            this.details.set(item.customer_id, detail);
        } catch (e) {
            ErrorsStore.addError(e, customError);
            console.warn(e);
            return false;
        }
    });

    @action
    deleteCustomerCard = flow(function*(item) {
        let customError = _('There was a problem creating the credit card');
        try {
            const detail = yield fetch.post({
                url: `${this.baseUrl}/deleteCustomerCard`,
                body: { data: item },
            });
            if (detail.error) {
                console.log('detail.error', detail.error);
                ErrorsStore.addError(detail, customError);
            } else {
                ErrorsStore.addSuccess(
                    { userMessage: _('Credit Card deleted successfully') },
                    _('Operation Successfull')
                );
            }
        } catch (e) {
            ErrorsStore.addError(e, customError);
            console.warn(e);
            return false;
        }
    });

    @action
    createSubscription = flow(function*(item) {
        let customError = _('There was a problem creating the subscription');
        try {
            const detail = yield fetch.post({
                url: `${this.baseUrl}/createSubscription`,
                body: item,
            });
            if (detail.error) {
                ErrorsStore.addError(detail, customError);
            }
            return detail;
        } catch (e) {
            ErrorsStore.addError(e, customError);
            console.warn(e);
            return false;
        }
    });
}
export default new StripeStore();
